export default "https://assets.egbcdn.net/assets/packs/_/sounds/incoming_mail-a7c48a4aa35f78b345d02d653f798b08.mp3";